import http from "../index";

export const getDoctorPendingOrders = () => http.get("/subscription/waiting-doctor");
